import React from 'react';
import './Terms.css';

interface Props {
  onBack?: () => void;
}

export default function TratamientoDatos({ onBack }: Props) {
  return (
    <div className="terms-root">
      <div className="terms-card">
        <div className="terms-header">
          <DatabaseIcon />
          <div>
            <h1 className="terms-title">Política de Tratamiento de Datos Personales</h1>
            <p className="terms-subtitle">StorSafe · AndeanSoft SAS · Conforme a la LOPDP Ecuador · Versión 1.0</p>
          </div>
        </div>

        <div className="terms-body">

          <section className="terms-section">
            <h2>1. Identificación del responsable</h2>
            <p>
              <strong>AndeanSoft SAS</strong> es el responsable del tratamiento de los datos personales recopilados
              a través de la plataforma <strong>StorSafe</strong>, conforme a lo establecido en la{' '}
              <strong>Ley Orgánica de Protección de Datos Personales (LOPDP)</strong> de la República del Ecuador
              y su Reglamento de aplicación.
            </p>
            <p>
              Contacto del Delegado de Protección de Datos (DPD):{' '}
              <a href="mailto:jcifuentes@storsafe.app" style={{ color: '#2FBF71' }}>jcifuentes@storsafe.app</a>
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Categorías de datos tratados</h2>

            <h3 style={{ color: '#94a3b8', fontSize: '0.95rem', marginTop: 16, marginBottom: 8 }}>2.1 Datos personales de usuarios</h3>
            <p>StorSafe trata las siguientes categorías de datos personales de sus usuarios:</p>
            <ul>
              <li>Datos identificativos: nombre completo, correo electrónico, cargo y número telefónico.</li>
              <li>Datos de acceso: credenciales de autenticación (contraseñas cifradas), tokens de sesión.</li>
              <li>Datos de actividad: registros de auditoría de acciones realizadas en la plataforma.</li>
              <li>Datos técnicos: dirección IP, agente de usuario (navegador/dispositivo), timestamps de sesión.</li>
            </ul>

            <h3 style={{ color: '#94a3b8', fontSize: '0.95rem', marginTop: 16, marginBottom: 8 }}>2.2 Datos de sustancias químicas</h3>
            <p>
              La plataforma StorSafe gestiona información técnica sobre sustancias y productos químicos almacenados.
              Esta información incluye: nombres comerciales y técnicos, números CAS, clases de peligro SGA/GHS,
              hojas de seguridad (MSDS/SDS) y datos de compatibilidad. Esta información es de carácter técnico-industrial
              y <strong>no constituye datos personales</strong> en los términos de la LOPDP, ya que no se refiere a
              personas físicas identificadas o identificables.
            </p>
            <p>
              Sin embargo, su gestión está sujeta a las normativas ambientales, de seguridad industrial y de manejo
              de sustancias peligrosas aplicables en Ecuador, incluyendo la norma INEN 2266 y la normativa del
              Ministerio del Ambiente.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Finalidades del tratamiento</h2>
            <p>Los datos personales son tratados para las siguientes finalidades:</p>
            <ul>
              <li><strong>Prestación del servicio:</strong> gestión de cuentas de usuario, autenticación y control de acceso.</li>
              <li><strong>Administración empresarial:</strong> gestión multi-empresa, roles y permisos dentro de la plataforma.</li>
              <li><strong>Seguridad y auditoría:</strong> registro de operaciones para trazabilidad y cumplimiento normativo.</li>
              <li><strong>Facturación y soporte:</strong> gestión de planes de suscripción y atención al cliente.</li>
              <li><strong>Comunicaciones del servicio:</strong> notificaciones sobre cambios en el servicio, actualizaciones y alertas de seguridad.</li>
              <li><strong>Mejora del servicio:</strong> análisis agregado y anónimo del uso de la plataforma.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>4. Principios del tratamiento</h2>
            <p>El tratamiento de datos personales en StorSafe se rige por los siguientes principios de la LOPDP:</p>
            <ul>
              <li><strong>Licitud y lealtad:</strong> el tratamiento se basa en fundamentos jurídicos válidos.</li>
              <li><strong>Finalidad:</strong> los datos son recogidos para fines determinados, explícitos y legítimos.</li>
              <li><strong>Minimización:</strong> únicamente se recopilan los datos estrictamente necesarios.</li>
              <li><strong>Exactitud:</strong> los datos se mantienen actualizados y exactos.</li>
              <li><strong>Limitación del plazo de conservación:</strong> los datos no se conservan más tiempo del necesario.</li>
              <li><strong>Integridad y confidencialidad:</strong> se aplican medidas técnicas y organizativas de seguridad.</li>
              <li><strong>Responsabilidad proactiva:</strong> AndeanSoft SAS demuestra cumplimiento con la LOPDP.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Encargados del tratamiento</h2>
            <p>
              Para la prestación del servicio, AndeanSoft SAS utiliza los siguientes encargados del tratamiento,
              con quienes mantiene acuerdos de procesamiento de datos conformes a la LOPDP:
            </p>
            <ul>
              <li><strong>Supabase Inc.:</strong> infraestructura de base de datos y autenticación (alojada en AWS).</li>
              <li><strong>Resend / servicios de correo transaccional:</strong> envío de notificaciones de sistema.</li>
              <li><strong>Vercel / proveedor de hosting:</strong> alojamiento de la aplicación web.</li>
            </ul>
            <p>
              Todos los encargados están sujetos a obligaciones contractuales de confidencialidad y seguridad equivalentes
              a las exigidas por la LOPDP.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Transferencias internacionales</h2>
            <p>
              Algunos de nuestros proveedores de infraestructura operan fuera del Ecuador. Estas transferencias
              internacionales se realizan únicamente a países con un nivel de protección adecuado o bajo las garantías
              apropiadas (cláusulas contractuales tipo), conforme al artículo 54 de la LOPDP.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Plazos de conservación</h2>
            <ul>
              <li><strong>Datos de cuenta activa:</strong> durante la vigencia del contrato de servicio.</li>
              <li><strong>Registros de auditoría:</strong> mínimo 2 años conforme a normativa de seguridad industrial.</li>
              <li><strong>Datos de facturación:</strong> 7 años conforme a normativa tributaria ecuatoriana.</li>
              <li><strong>Tras cancelación de cuenta:</strong> los datos personales se eliminan o anonimizan en un plazo máximo de 30 días hábiles.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Derechos ARCO y adicionales</h2>
            <p>Los titulares de datos personales tienen los siguientes derechos conforme a la LOPDP:</p>
            <ul>
              <li><strong>Acceso (Art. 68):</strong> obtener confirmación de si se tratan sus datos y acceder a ellos.</li>
              <li><strong>Rectificación (Art. 69):</strong> corregir datos inexactos o completar datos incompletos.</li>
              <li><strong>Cancelación/Supresión (Art. 70):</strong> solicitar la eliminación de sus datos personales.</li>
              <li><strong>Oposición (Art. 71):</strong> oponerse al tratamiento de sus datos por motivos legítimos.</li>
              <li><strong>Portabilidad (Art. 72):</strong> recibir sus datos en formato estructurado e interoperable.</li>
              <li><strong>No ser objeto de decisiones automatizadas:</strong> solicitar intervención humana en decisiones automatizadas.</li>
            </ul>
            <p>
              Para ejercer sus derechos, envíe una solicitud escrita a:{' '}
              <a href="mailto:jcifuentes@storsafe.app" style={{ color: '#2FBF71' }}>jcifuentes@storsafe.app</a>
              {' '}indicando: nombre completo, derecho que desea ejercer y descripción de su solicitud.
              Daremos respuesta en un plazo máximo de <strong>15 días hábiles</strong>.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Reclamaciones ante la autoridad de control</h2>
            <p>
              Si considera que el tratamiento de sus datos personales no se ajusta a la normativa vigente, tiene
              derecho a presentar una reclamación ante la{' '}
              <strong>Autoridad de Protección de Datos Personales del Ecuador</strong>, conforme al artículo 9
              de la LOPDP.
            </p>
          </section>

          <section className="terms-section terms-section-last">
            <h2>10. Actualización de esta política</h2>
            <p>
              Esta política puede ser actualizada para reflejar cambios en la normativa aplicable o en las prácticas
              de tratamiento de datos. Los cambios serán comunicados con al menos 15 días de anticipación.
            </p>
            <p>
              <strong>Última actualización:</strong> enero 2026 ·{' '}
              <a href="mailto:jcifuentes@storsafe.app" style={{ color: '#2FBF71' }}>jcifuentes@storsafe.app</a>
            </p>
          </section>

        </div>

        {onBack && (
          <div style={{ padding: '0 32px 28px' }}>
            <button onClick={onBack} style={{ background: 'none', border: '1px solid #334155', color: '#94a3b8', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: '0.88rem' }}>
              ← Volver
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function DatabaseIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
      <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
    </svg>
  );
}
